
module.config(function($stateProvider) {

    $stateProvider.state('program.grants', {
        url: '/grants',
        templateUrl: 'programs/grants/grants',
        controller: 'GrantIndexController',
        resolve: {
            grants: function(ModelService, program) {
                return ModelService.getModelRelation(program, 'grants', {
                    no_page: true,
                });
            },
            auth: function($checkPermissions, permissions) {
                return $checkPermissions('viewGrants', permissions);
            }
        }
    });
});
